var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 13,
    viewBox: "0 0 69 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35441 0.381348L7.73331 4.62516H12.1955L8.58551 7.24798L9.96441 11.4918L6.35441 8.86897L2.74441 11.4918L4.12331 7.24798L0.513304 4.62516H4.97551L6.35441 0.381348Z",
    fill: "#F5CA40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4795 0.381348L21.8584 4.62516H26.3206L22.7106 7.24798L24.0895 11.4918L20.4795 8.86897L16.8695 11.4918L18.2484 7.24798L14.6383 4.62516H19.1006L20.4795 0.381348Z",
    fill: "#F5CA40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6065 0.381348L35.9854 4.62516H40.4476L36.8376 7.24798L38.2165 11.4918L34.6065 8.86897L30.9965 11.4918L32.3754 7.24798L28.7654 4.62516H33.2276L34.6065 0.381348Z",
    fill: "#F5CA40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7316 0.381348L50.1105 4.62516H54.5727L50.9627 7.24798L52.3416 11.4918L48.7316 8.86897L45.1216 11.4918L46.5005 7.24798L42.8905 4.62516H47.3527L48.7316 0.381348Z",
    fill: "#F5CA40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8583 0.381348L64.2372 4.62516H68.6994L65.0894 7.24798L66.4683 11.4918L62.8583 8.86897L59.2483 11.4918L60.6272 7.24798L57.0172 4.62516H61.4794L62.8583 0.381348Z",
    fill: "#F5CA40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRating);
export default __webpack_public_path__ + "static/media/starRating.37608a7d54a67ba4844903acc3975137.svg";
export { ForwardRef as ReactComponent };